import { Grid2, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { twoStepScanPath } from 'components/Routes'
import Button from 'components/Button'
import AuthyPath from 'images/Authy.png'
import DuoPath from 'images/Duo.png'
import GoogleAuthenticatorPath from 'images/GoogleAuthenticator.png'
import MicrosoftAuthenticatorPath from 'images/MicrosoftAuthenticator.png'

export default function TwoStepDownload(): JSX.Element {
  const navigate = useNavigate()

  function handleClick() {
    navigate(twoStepScanPath())
  }

  const images = [
    {
      src: AuthyPath,
      alt: 'authy'
    },
    {
      src: GoogleAuthenticatorPath,
      alt: 'google_authenticator'
    },
    {
      src: MicrosoftAuthenticatorPath,
      alt: 'microsoft_authenticator'
    },
    {
      src: DuoPath,
      alt: 'duo'
    }
  ]

  return (
    <Grid2 container>
      <Grid2 size={{ xs: 12 }}>
        <Typography
          align='left'
          variant='h2'
          fontSize='48px'
          textTransform='uppercase'
        >
          Download app
        </Typography>
      </Grid2>
      <Grid2 mb={4} size={{ xs: 12 }}>
        <Typography align='left' fontSize='medium'>
          There are lots of options available, e.g. Google Authenticator, Authy.
        </Typography>
      </Grid2>
      <Grid2 container spacing={2}>
        {images.map(image => (
          <Grid2 key={image.alt} size={{ xs: 6 }}>
            <img
              src={image.src}
              alt={image.alt}
              style={{ objectFit: 'cover', width: '100%' }}
            />
          </Grid2>
        ))}
      </Grid2>
      <Grid2 sx={{ mt: 4, textAlign: 'center' }} size={{ xs: 12 }}>
        <Button color='primary' fullWidth onClick={handleClick}>
          Next
        </Button>
      </Grid2>
    </Grid2>
  )
}
